export enum UserRoles {
  SUPER_ADMIN = "Super admin",
  ADMIN = "Admin",
  MASTER = "Master",
}
